/** MUI 主题创建与导出 */

import { createTheme } from '@mui/material/styles';
import { palette } from './palette';
import { typography } from './typography';

const theme = createTheme({
  palette,
  typography,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
          padding: '8px 16px',
        },
        containedPrimary: {
          // 设计稿主按钮：翡翠绿渐变 + 柔和绿影
          background: 'linear-gradient(135deg, #34D399 0%, #0F9D6F 100%)',
          boxShadow: '0 6px 16px rgba(16,185,129,0.24)',
          fontWeight: 600,
          '&:hover': {
            background: 'linear-gradient(135deg, #2BC48C 0%, #0B8A61 100%)',
            boxShadow: '0 8px 20px rgba(16,185,129,0.32)',
          },
          '&.Mui-disabled': {
            background: '#E3EAE6',
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 6px 22px rgba(16,80,60,0.06), 0 1px 2px rgba(16,80,60,0.04)',
          border: '1px solid rgba(16,185,129,0.08)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // iOS Safari 输入框字号 < 16px 聚焦时会自动放大页面：窄屏统一 16px
          '@media (max-width: 899.95px)': {
            fontSize: 16,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: '#F7FAF8',
            fontWeight: 600,
            color: '#4B5E55',
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
            padding: '12px 16px',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #EEF4F1',
          padding: '12px 16px',
          fontSize: '13px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 12,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        },
      },
    },
  },
});

export default theme;
